<template>
  <div id="app" :style="{height:height+'px'}"> 
    <keep-alive>      
        <router-view v-if="$route.meta.keepAlive"/>    
    </keep-alive>    
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
import appService from "@/services/request/appService"
export default {
  name: "app",
  data() {
    return {
      isShowTopNav: false,
      height:window.innerHeight
    }
  },
  created() {
    if (window.location.pathname == "/") {
      this.initiidInfo();
      // return;
      // this.init_();
    }

    if(window.location.href.indexOf('/o/') != -1){
      console.log(window.location.href.split('/o/'))
      let urlArr = window.location.href.split('/o/')
      this.$router.push({
        path: '/m/a/list',
        query:{
          iid: urlArr[1]
        }
      })
      console.log(666)
    }

    console.log(this.$route)
  },
  methods: {
    initiidInfo(callback) {
      var domainStr = window.location.host
      if (!navigator.userAgent.match(/MicroMessenger\//) &&
        (window.location.host.indexOf('localhost:') != -1) ||
        window.location.host.indexOf(':8080') != -1) {
        domainStr = 'morigin.huaxiyou.cc'
      }
      appService
        .getiidByDomain({
          domainName: domainStr,
        })
        .then(data => {
          if(data) {
            // this.img = data.img
            // this.mine.iid = data.iid
            // this.mine.iname = data.iname
            // document.title = data.iname+'智慧地接'
            this.$router.push({
              path: '/m/a/list',
              query:{
                iid: data.iid
              }
            })
            if(typeof callback === 'function') callback()
          }
        })
    },
  },
}
</script>

<style lang="less">
html,body{
  overflow: hidden;
}
#app {
  height: 100%;
  background-color: #f6f6f6;
  overflow: hidden;
  .yd-scrollview{
    display: flex;
    flex-direction: column;
    
  }
  .yd-scrollview:after{
    height: 0;
  }
}
</style>
